import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import useTranslation from '@hooks/useTranslation';

import type { ILanguage } from '@model/language';

import { apiClient } from '@services/apiClient';

export const languageListKey = () => ['languageList'];
export const languageListFn = () => apiClient.get(`${APP_API_URL_V2}fsd/language/list`);

const languageList = (data: Array<ILanguage>, t: (text: string) => string) => {
  const filteredLanguages: Array<ILanguage> = [];

  data?.forEach((language) => {
    if (+language.is_translatable === 1 && language.iso_code !== 'af') {
      filteredLanguages.push({ ...language, name: t(language.name), original_name: language.name });
    }
  });

  return filteredLanguages?.sort((a, b) => a.name.localeCompare(b.name)) || [];
};

export const useLanguageListQuery = () => {
  const { t } = useTranslation();

  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: languageListKey(),
    queryFn: languageListFn,
    select: ({ data }: AxiosResponse<{ data: Array<ILanguage> }>) => languageList(data.data, t),
    placeholderData: {
      data: { data: [] },
    },
  });
};
